module.exports = __webpack_public_path__ + "images/花筑奢pr长图_06-6.jpg?v=2f8aa822";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_06-6.jpg
 ** module id = 42
 ** module chunks = 1 2
 **/